module.exports = __webpack_public_path__ + "static/img/chrome.acfbef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chrome.png
// module id = mzhJ
// module chunks = 1